module.exports = __webpack_public_path__ + "img/img1.7c0d234.png";